module.exports = __webpack_public_path__ + "img/resources2.5e7d108a.jpg";